import store from '@/store'
import * as R from 'ramda'
export function checkPermission (groups) {
    switch (arguments.length) {
        case 0:
            return false
        case 1: {
            let groupsInProfile = R.path(['state', 'userProfile', 'groups'], store)
            return R.gt(R.length(R.intersection(groupsInProfile ? groupsInProfile : [], groups ? groups : [])), 0)
        }
        case 2:
            break;
        default:
            return false
        }
}

export function getPermission(metaDataPerm) {
    let userGroup = R.path(['state', 'userProfile', 'groups'], store)
    return R.flatten(R.values(R.pick(userGroup ? userGroup : [], metaDataPerm ? metaDataPerm : {})).map(item => R.keys(item)))
}

export function canInCollection(action, collection) {
    let perm = R.keys(R.path(['state','userProfile', 'specificPermission', collection], store))
    return R.contains(action, perm ? perm : [])
}